import { ArrowRight, FileCheck2, Goal, ScanSearch } from 'lucide-react'
import { PageHero } from '../components/PageHero'
import { PageMeta } from '../components/PageMeta'
import { ProcessSteps } from '../components/ProcessSteps'

export function ApproachPage() {
  return (
    <main id="main-content" className="route-page">
      <PageMeta
        title="How Informat works"
        description="A clear technology engagement from understanding and design through implementation, documentation and handover."
      />
      <PageHero
        className="editorial-hero"
        title={
          <>
            Clear thinking before technology.
            <span className="text-cursor" aria-hidden="true" />
          </>
        }
        body="The work starts with the outcome, the environment and the people who depend on it. The right scope follows from understanding those properly."
        primary={{ href: '#process', label: 'See the approach' }}
        secondary={{ href: '/contact', label: 'Discuss a project' }}
        visual={
          <div className="approach-blueprint" aria-hidden="true">
            <span>Understand</span>
            <span>Design</span>
            <span>Implement</span>
            <span>Document</span>
            <span>Hand over</span>
          </div>
        }
      />
      <section className="approach-process section-light" id="process" aria-labelledby="process-title">
        <div className="approach-process__intro" data-reveal>
          <h2 id="process-title">A disciplined route from problem to outcome.</h2>
          <p>
            The detail changes with the project. The principles—clarity, control, validation,
            documentation and ownership—remain consistent.
          </p>
        </div>
        <ProcessSteps />
      </section>
      <section className="engagement-principles section-dark" aria-labelledby="principles-title">
        <h2 id="principles-title" data-reveal>
          What stays consistent.
        </h2>
        <div>
          <article data-reveal>
            <ScanSearch aria-hidden="true" strokeWidth={1.2} />
            <h3>Start with evidence</h3>
            <p>Understand what exists and what is unknown before committing to a technical route.</p>
          </article>
          <article data-reveal>
            <Goal aria-hidden="true" strokeWidth={1.2} />
            <h3>Keep scope visible</h3>
            <p>Agree what the engagement is intended to achieve and what needs separate ownership.</p>
          </article>
          <article data-reveal>
            <FileCheck2 aria-hidden="true" strokeWidth={1.2} />
            <h3>Finish with clarity</h3>
            <p>Validate the work, document the result and make the next responsibility explicit.</p>
          </article>
        </div>
      </section>
      <section className="closing-cta section-light closing-cta--light">
        <div>
          <h2>Have a defined problem? Or just know something needs to work better?</h2>
          <p>Both are sensible places to start.</p>
        </div>
        <a href="/contact">
          Discuss the next step <ArrowRight aria-hidden="true" />
        </a>
      </section>
    </main>
  )
}
